import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { FormField } from '@/components/forms';
import type { SubscriptionPlanFormData, SubscriptionPlan } from '../types';

export interface PlanFormState {
  code: string;
}

export function buildPlanFormState(plan?: SubscriptionPlan): PlanFormState {
  return {
    code: plan?.code ?? '',
  };
}

interface FormFieldsProps {
  isEdit: boolean;
  formLoading: boolean;
  initialState: PlanFormState;
  onFinish: (values: SubscriptionPlanFormData) => Promise<void>;
  renderFooter?: (submit: () => void, loading: boolean) => React.ReactNode;
}

export function SubscriptionPlanFormFields({
  isEdit,
  formLoading,
  initialState,
  onFinish,
  renderFooter,
}: FormFieldsProps) {
  const [code, setCode] = useState(initialState.code);

  const handleSubmit = async () => {
    const formData: SubscriptionPlanFormData = {
      code,
    };

    await onFinish(formData);
  };

  return (
    <div className="space-y-6 pt-6">
      <div className="max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle>Основные настройки</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <FormField
              label="Код абонемента"
              name="code"
              required
              hint="Уникальный идентификатор (латиница, цифры, дефис, подчёркивание). Цены, сроки, права доступа и другие параметры настраиваются в тарифах."
            >
              <Input
                value={code}
                onChange={(e) => setCode(e.target.value.toLowerCase())}
                placeholder="monthly-basic"
                disabled={isEdit}
              />
            </FormField>
          </CardContent>
        </Card>
      </div>

      {renderFooter?.(() => { void handleSubmit(); }, formLoading)}
    </div>
  );
}
